/* thepostcard.shop house behaviour: reveals, city chapters and date-gated pieces. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sda = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('animation-timeline: view()');
  const clamp = (v) => Math.min(1, Math.max(0, v));

  function initReveals(root) {
    const els = root.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach((el) => io.observe(el));
  }

  function initChapters(root) {
    const chapters = [...root.querySelectorAll('.tps-chapter:not([data-ready])')];
    if (!chapters.length || reduce) return;
    const active = new Set();

    chapters.forEach((ch) => {
      ch.dataset.ready = '';
      if (sda) ch.setAttribute('data-sda', '');
      else if ('IntersectionObserver' in window) {
        // Fallback: swap when the midpoint sentinel passes the middle of the viewport.
        const s = ch.querySelector('.tps-chapter__sentinel');
        new IntersectionObserver(([e]) => {
          ch.classList.toggle('is-swapped', e.boundingClientRect.top < innerHeight / 2);
        }, { rootMargin: '0px 0px -50% 0px', threshold: 0 }).observe(s);
      }
      new IntersectionObserver(([e]) => {
        if (e.isIntersecting) active.add(ch); else active.delete(ch);
        if (active.size) tick();
      }).observe(ch);
    });

    let queued = false;
    function tick() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        active.forEach((ch) => {
          const r = ch.getBoundingClientRect();
          const p = clamp(-r.top / Math.max(1, r.height - innerHeight));
          const [a, b] = ch.querySelectorAll('postcard-3d');
          if (a) a.progress = clamp(p / 0.34);
          if (b) b.progress = clamp((p - 0.62) / 0.34);
        });
      });
    }
    addEventListener('scroll', () => { if (active.size) tick(); }, { passive: true });
  }

  // Date-gated pieces (e.g. the Diwali stamps): hide once data-tps-until (Unix seconds) has passed,
  // even when the page was cached before the date.
  function initUntil(root) {
    const now = Date.now() / 1000;
    root.querySelectorAll('[data-tps-until]').forEach((el) => {
      const until = Number(el.getAttribute('data-tps-until'));
      if (until && now >= until) el.hidden = true;
    });
  }

  function init(root = document) { initUntil(root); initReveals(root); initChapters(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
